<template>
  <!-- 龋齿筛查  -->
  <div v-if="model && model.dentalCaries">
    <div id="print_dentalCaries" class="page dentalCaries-page" style="margin:0 auto; border:0px solid #E8E8EC;">

      <div style="height: 50px;"></div>
      <div style="font-size: 18px;"><span>{{ model.dentalCaries.hospitalName ? model.dentalCaries.hospitalName : "" }}</span></div>
      <div style="font-size: 22px;padding: 20px 0 30px 0;font-weight: 600;"><span>{{ model.dentalCaries.reportName ? model.dentalCaries.reportName : "龋易感性检测报告" }}</span></div>

      <table style="margin-top: 15px;text-align: left;width: 100%;border-collapse: collapse;border:none;border-bottom:1px solid rgb(14, 14, 14);">
        <tbody>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">学校：<span>{{ model.dentalCaries.schoolName ? model.dentalCaries.schoolName : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">年级：<span>{{ model.dentalCaries.gradeName ? model.dentalCaries.gradeName : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">班级：<span>{{ model.dentalCaries.className ? model.dentalCaries.className : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">编号：<span>{{ model.dentalCaries.barCode ? model.dentalCaries.barCode : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">筛查时间：<span>{{ model.dentalCaries.screeningTime ? model.dentalCaries.screeningTime : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">姓名：<span>{{ model.dentalCaries.name ? model.dentalCaries.name : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">性别：<span>{{ model.dentalCaries.sex ? model.dentalCaries.sex : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">年龄：<span>{{ model.dentalCaries.age ? model.dentalCaries.age : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <div style="width: 98%;text-align: left;margin-top: 20px;border-bottom:1px solid rgb(14, 14, 14);">
        <div style="font-size: 18px;font-weight: bold;">筛查结果</div>
        <div style="display: table;width:100%;">
          <div style="display: table-cell;width:12%;flex: 1; text-align: center;">
            <div style="padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;"></div><div>CAT值:</div></div>
          <div style="display: table-cell;width:12%;flex: 1; text-align: center;">
            <div style="background: rgb(83, 97, 164);padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;"></div>
            <div style="padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;">0</div>
          </div>
          <div style="display: table-cell;width:12%;flex: 1; text-align: center;">
            <div style="background: rgb(93, 137, 134);padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;"></div>
            <div style="padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;">0.5</div>
          </div>
          <div style="display: table-cell;width:12%;flex: 1; text-align: center;">
            <div style="background: rgb(142, 186, 111);padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;"></div>
            <div style="padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;">1.0</div>
          </div>
          <div style="display: table-cell;width:12%;flex: 1; text-align: center;">
            <div style="background: rgb(181, 204, 103);padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;"></div>
            <div style="padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;">1.5</div>
          </div>
          <div style="display: table-cell;width:12%;flex: 1; text-align: center;">
            <div style="background: rgb(181, 204, 103);padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;"></div>
            <div style="padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;">2.0</div>
          </div>
          <div style="display: table-cell;width:12%;flex: 1; text-align: center;">
            <div style="background: rgb(214, 210, 89);padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;"></div>
            <div style="padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;">2.5</div>
          </div>
          <div style="display: table-cell;width:12%;flex: 1; text-align: center;">
            <div style="background: rgb(250, 225, 76);padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;"></div>
            <div style="padding: 3px 0;height: 40px;width: 60px;position: relative;top: 0;left: 0;">3.0</div>
          </div>
        </div>

        <table style="width: 80%;margin-left:10%;text-align: center;margin-top: 10px;margin-bottom: 50px;border-collapse: collapse;border:none;">
          <tbody>
            <tr style="background: rgb(248, 249, 249);line-height: 35px;">
              <td style="width: 100px;border-collapse: collapse;border:none;">项目名称</td>
              <td style="width: 100px;border-collapse: collapse;border:none;">结果</td>
              <td style="width: 100px;border-collapse: collapse;border:none;">参考值</td>
            </tr>
            <tr style="line-height: 35px;">
              <td style="width: 100px;border-collapse: collapse;border:none;">{{ model.dentalCaries.cariogenicBacteriaName ? model.dentalCaries.cariogenicBacteriaName : "" }}</td>
              <td style="width: 100px;border-collapse: collapse;border:none;">{{ model.dentalCaries.cariogenicBacteria ? model.dentalCaries.cariogenicBacteria : "" }}</td>
              <td style="width: 100px;border-collapse: collapse;border:none;">{{ model.dentalCaries.cariogenicBacteriaReference ? model.dentalCaries.cariogenicBacteriaReference : "" }}</td>
            </tr>
            <tr style="line-height: 35px;">
              <td style="width: 100px;border-collapse: collapse;border:none;">{{ model.dentalCaries.catValueName ? model.dentalCaries.catValueName : "" }}</td>
              <td style="width: 100px;border-collapse: collapse;border:none;">{{ model.dentalCaries.catValue ? model.dentalCaries.catValue : "" }}</td>
              <td style="width: 100px;border-collapse: collapse;border:none;">{{ model.dentalCaries.catValueReference ? model.dentalCaries.catValueReference : "" }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <table style="margin-top: 10px;width: 100%;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="text-align: left;" valign="top">
            <td style="width: 100px;border-collapse: collapse;border:none;">
              <div><p style="font-size: 16px;font-weight: bold;">【筛查小结】</p></div>
              <div style="min-height: 20px;"><p>{{ model.dentalCaries.screeningSummary ? model.dentalCaries.screeningSummary : "" }}</p></div>
            </td>
          </tr>
          <tr style="text-align: left;" valign="top">
            <td style="width: 100px;border-collapse: collapse;border:none;">
              <div><p style="font-size: 16px;font-weight: bold;">【建议】</p></div>
              <div style="min-height: 20px;"><p>{{ model.dentalCaries.recommendations ? model.dentalCaries.recommendations : "" }}</p></div>
            </td>
          </tr>
          <tr style="text-align: left;" valign="top">
            <td style="width: 100px;border-collapse: collapse;border:none;">
              <div><p style="font-size: 16px;font-weight: bold;">【温馨提示】</p></div>
              <div style="min-height: 20px;"><p>{{ model.dentalCaries.tips ? model.dentalCaries.tips : "" }}</p></div>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>

</template>
<script>

import {_dentalCaries} from "@/services/report/report";
export default {
  name: "dentalCariesReport",
  props: {
    physicalId: [String, Number],
    barCode: [String, Number],
    reportCode: [String],
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      model: {
        dentalCaries:{
          reportName: "",
          hospitalName: "",
          name: "",
        }
      },
    }
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'dentalCaries'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'dentalCaries') {
          this.model = newVal;
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods:{
    loadData(){
      if(this.barCode){
        this.dentalCaries(this.barCode);
      }
    },
    dentalCaries(barCode) {
      _dentalCaries({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
      })
    },
  }
};
</script>
<style lang="postcss" scoped>
@media print {
  .dentalCaries-page {
    page: dentalCaries-page; /* 绑定唯一命名 */
  }
  @page dentalCaries-page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {width: 210mm;height: 297mm;text-align: center;margin:0 auto;padding-top:10px;padding-left:30px;padding-right:30px;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;background: #fff;}

</style>
